import { ProviderDataStep } from '../../generated'

export type OnboardingSteps = Exclude<ProviderDataStep, 'incompleteVehicleData'>

export type StepDetailType = {
  title: string
  tooltip: string
  icon: React.ReactNode
  action: () => void
}

export type OnboardingFlow = {
  requiredSteps: OnboardingSteps[]
  additionalSteps: OnboardingSteps[]
}

export const ONBOARDING_STEPS: OnboardingFlow = {
  requiredSteps: [
    'incompleteTeslaConnection',
    'incompleteVehicles',
    'incompleteStripeConnect',
    'incompleteProviderPaymentMethod',
  ],
  additionalSteps: [
    'incompletePricing',
    'incompleteBookingLocations',
    'incompleteVehicleLocations',
    'incompleteSubscriptions',
    'incompleteSubscriptionPrices',
    'incompleteRentalTerms',
    'incompleteTeamMembers',
  ],
}

export const ONBOARDING_BOOKING_STEPS: OnboardingFlow = {
  requiredSteps: [
    'incompleteTeslaConnection',
    'incompleteVehicles',
    'incompleteStripeConnect',
    'incompletePricing',
    'incompleteBookingLocations',
    'incompleteVehicleLocations',
    'incompleteProviderPaymentMethod',
  ],
  additionalSteps: [
    'incompleteSubscriptions',
    'incompleteSubscriptionPrices',
    'incompleteRentalTerms',
    'incompleteTeamMembers',
  ],
}

export const ONBOARDING_SUBSCRIPTION_STEPS: OnboardingFlow = {
  requiredSteps: [
    'incompleteTeslaConnection',
    'incompleteVehicles',
    'incompleteStripeConnect',
    'incompleteSubscriptions',
    'incompleteSubscriptionPrices',
    'incompleteProviderPaymentMethod',
  ],
  additionalSteps: [
    'incompleteBookingLocations',
    'incompleteVehicleLocations',
    'incompletePricing',
    'incompleteRentalTerms',
    'incompleteTeamMembers',
  ],
}
